import { render, staticRenderFns } from "./DefaultBanner.vue?vue&type=template&id=4ded8803&scoped=true"
import script from "./DefaultBanner.vue?vue&type=script&lang=js"
export * from "./DefaultBanner.vue?vue&type=script&lang=js"
import style0 from "./DefaultBanner.vue?vue&type=style&index=0&id=4ded8803&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ded8803",
  null
  
)

export default component.exports